export default "__VITE_ASSET__BhiMEk6v__"